import { useState } from 'react';
import clsx from 'clsx';
import { CORRECT_CODES, SHAPES } from './config';
import { DigitInput } from './DigitInput';

interface Props {
  codeIndex: number;
  locked: boolean;
  onCorrect: () => void;
}

export const CodeInput = ({ codeIndex, locked, onCorrect }: Props) => {
  const [digits, setDigits] = useState<number[]>([0, 0, 0]);

  const handleDigitChange = (digitIndex: number, value: number) => {
    if (locked) return;

    const newDigits = [...digits];
    newDigits[digitIndex] = value;
    setDigits(newDigits);

    // Check if the code is correct
    const enteredCode = newDigits.join('');
    if (enteredCode === CORRECT_CODES[codeIndex]) {
      onCorrect();
    }
  };

  const SVGElement = SHAPES[codeIndex];

  return (
    <div className="flex flex-col items-center gap-4 md:gap-8">
      <div className={clsx('flex items-center justify-center', locked && '[&_path]:[stroke-dasharray:0] [&_rect]:[stroke-dasharray:0]')}>
        <SVGElement />
      </div>

      <div className="flex gap-4 md:gap-1 items-center">
        {digits.map((digit, index) => (
          <DigitInput key={index} value={digit} onChange={value => handleDigitChange(index, value)} locked={locked} />
        ))}
      </div>
    </div>
  );
};
